import React from 'react';
import { createIcon } from './create-icon';
import './icon-info.scss';

export const IconInfo = createIcon(<div className="icon-info" />);
